import { render, staticRenderFns } from "./WABAAdOptimization.vue?vue&type=template&id=61994706&scoped=true"
import script from "./WABAAdOptimization.vue?vue&type=script&lang=js"
export * from "./WABAAdOptimization.vue?vue&type=script&lang=js"
import style0 from "./WABAAdOptimization.vue?vue&type=style&index=0&id=61994706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61994706",
  null
  
)

export default component.exports